<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Home</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div v-if="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
      </div>
      <div v-if="errorMessages.length" class="alert alert-danger" role="alert">
        <p v-for="message in errorMessages">{{ message }}</p>
      </div>
      <h2 class="text-center">Listados de menús web</h2>
      <menus-table
              :menus="menus"
              :environment="environment"
              @delete_menu="onDeleteMenu"
      />
      <div class="text-center layer-button">
        <button v-if="userIsAdmin" class="btn btn-primary" @click="$router.push('addMenu')" >Crear nuevo menú web</button>
      </div>
    </div>
    <div v-if="showLoader" class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <confirm-delete-menu
            :visible="showModalFlag"
            @close_delete_menu="onModalClose"
            @confirm_delete_menu="onModalConfirmed"
    />
    <div v-if="isDevServer"><pre>{{ menus }}</pre></div>
  </div>
</template>

<script>

import axios from 'axios';
import Url from '@/core/Url.js'
import BaseView from '@/views/Base.vue'
import MenusTable from '@/components/Tables/MenusTable.vue'
import ConfirmDeleteMenu from '@/components/Modals/ConfirmDeleteMenu.vue'

export default {
  name: 'Home',
  extends: BaseView,
  components: {
    'menus-table' : MenusTable,
    'confirm-delete-menu' : ConfirmDeleteMenu
  },
  data () {
    return {
      menus : [],
      showModalFlag : false,
      menuIdToDelete : null,
    };
  },
  methods: {
    initMenus () {
      this.menus = [];
      this.showLoader = true;
      axios
        .get(this.getMenusListUrl())
        .then(response => {
          if (response.data.result) {
            this.menus = response.data.data
          } else {
            this.errorMessages.push('Se ha producido un error al consultar los menús.');
          }
        }).catch(() => {
          this.errorMessages.push('Se ha producido un error al consultar los menús.');

        }).finally (() => {
          this.showLoader = false;
        });
    },
    deleteMenu () {
      axios
        .delete(this.getMenuUrl(), { data: {id : this.menuIdToDelete} })
        .then(response => {
          if (response.data.result) {
            this.successMessage = 'Se ha eliminado el menú correctamente.';
          } else {
            this.errorMessages.push('Se ha producido un error al eliminar el menú.');
          }
        }).catch(() => {
          this.errorMessages.push('Se ha producido un error al eliminar el menú.');
        }).finally (() => {
          this.initMenus ();
        });
    },
    onDeleteMenu (menuId) {
      this.menuIdToDelete = menuId;
      this.showModal ();
    },
    onModalClose () {
      this.hideModal ();
      this.menuIdToDelete = null;
    },
    onModalConfirmed () {
      this.hideModal ();
      this.deleteMenu();
      this.menuIdToDelete = null;
    },
    hideModal () {
      this.showModalFlag = false;
    },
    showModal () {
      this.showModalFlag = true;
    },
    getMenusListUrl: function () {
      return Url.getMenusListUrl();
    },
    getMenuUrl: function () {
      return Url.getMenuUrl();
    },
  },
  created () {
    this.initMenus ();
  }
}
</script>

<style>
  .layer-button {
    padding: 20px
  }
</style>
